import React, { createContext, useContext } from 'react';

const ActionScopeContext = createContext('event');
const ActionSettingsPayloadContext = createContext(null);
const ActionSettingsCommandContext = createContext(null);
const ActionCaseIdContext = createContext(null);
const ActionEditorControlsContext = createContext(null);
const ActionEditorGeneralSettingsContext = createContext(null);

export const ActionScopeProvider = ({
  scope = 'event',
  caseid = null,
  setting = null,
  sendActionCommand = null,
  registerEditorControls = null,
  editorGeneralSettings = null,
  children
}) => (
  <ActionEditorGeneralSettingsContext.Provider value={editorGeneralSettings}>
    <ActionEditorControlsContext.Provider value={registerEditorControls}>
      <ActionSettingsCommandContext.Provider value={sendActionCommand}>
        <ActionSettingsPayloadContext.Provider value={setting}>
          <ActionCaseIdContext.Provider value={caseid}>
            <ActionScopeContext.Provider value={scope || 'event'}>
              {children}
            </ActionScopeContext.Provider>
          </ActionCaseIdContext.Provider>
        </ActionSettingsPayloadContext.Provider>
      </ActionSettingsCommandContext.Provider>
    </ActionEditorControlsContext.Provider>
  </ActionEditorGeneralSettingsContext.Provider>
);

export const useActionScope = () => useContext(ActionScopeContext) || 'event';
export const useActionSettingsPayload = () => useContext(ActionSettingsPayloadContext);
export const useActionSettingsCommand = () => useContext(ActionSettingsCommandContext);
export const useActionCaseId = () => useContext(ActionCaseIdContext);
export const useActionEditorControls = () => useContext(ActionEditorControlsContext);
export const useActionEditorGeneralSettings = () => useContext(ActionEditorGeneralSettingsContext);

export default ActionScopeContext;
